const DownArrow = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="23" height="23" rx="5.5" fill="#F2F3F5" />
      <rect x="0.5" y="0.5" width="23" height="23" rx="5.5" stroke="#D7D7D8" />
      <path
        d="M16 10L12 14L8 10"
        stroke="#57585C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default DownArrow;
